(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@antv/layout@alpha"));
	else if(typeof define === 'function' && define.amd)
		define(["@antv/layout@alpha"], factory);
	else if(typeof exports === 'object')
		exports["LayoutGPU"] = factory(require("@antv/layout@alpha"));
	else
		root["LayoutGPU"] = factory(root["Layout"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__664__) => {
return 